module.exports = __webpack_public_path__ + "img/incentive.a15b7fdd.png";